import { ThemesContent } from '../types';

export const JVCEF: ThemesContent = {
  colors: {
    light: '#195C9D',
    copyRightColor: '#ffffff',
    privacyColor: '#F7941E',
  },
};
